var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentCrystalHarvested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8915 11.4783C19.963 10.9959 20 10.5023 20 10C20 8.57779 19.7031 7.22492 19.1679 6H24V11.4783H19.8915ZM18.5217 15.2353C19.0795 14.3294 19.4968 13.3278 19.7434 12.2609H24V17.7391H18.5217V15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434C13.3278 19.4968 14.3294 19.0795 15.2353 18.5217H17.7391V24H12.2609V19.7434ZM6 19.1679C7.22492 19.7031 8.57779 20 10 20C10.5023 20 10.9959 19.963 11.4783 19.8915V24H6V19.1679ZM24 18.5217H18.5217V24H24V18.5217Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6441_460035)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#4CAF50",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.75L12.9491 7.89625L11.2237 8.8472L9.96357 7.02049L12 5.75ZM9.90681 7.15314L11.1394 8.93993L10.5415 11.1229L10.1007 8.14122L10.0944 8.0982L10.0636 8.06858L9.91033 7.92123L9.88008 7.22661L9.90681 7.15314ZM10.8782 12.1515L10.8863 12.1579L11.6399 9.87936L10.8782 12.1515ZM11.6413 9.87729L12.5151 9.31572L12.5188 9.30617L11.6413 9.87729ZM10.4339 11.2209L10.4119 11.2591L10.0418 10.9398L9.91808 8.09917L9.98148 8.16012L10.4339 11.2209ZM10.7768 12.0728L10.7657 12.0642L10.6149 11.8455L10.5855 11.42L11.2563 8.97071L12.9002 8.0647L12.5937 9.10985L11.5762 9.77213L11.5403 9.79548L11.5264 9.83693L10.7768 12.0728Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6413 9.87729L12.515 9.31571L12.5188 9.30616L11.6413 9.87729ZM10.776 12.0749L10.7656 12.0642L10.6148 11.8455L10.5854 11.42L11.2563 8.97071L12.9002 8.0647L12.5937 9.10985L11.5761 9.77213L11.5403 9.79548L11.5264 9.83693L10.776 12.0749Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.75L12.9491 7.89625L11.2237 8.8472L9.96357 7.02049L12 5.75Z",
    fill: "#88CA8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07019 8.87826L7.72013 6.05157L9.19308 11.6063L9.13688 11.6894L8.35266 9.40944L7.07019 8.87826ZM10.5079 11.6964L9.77028 10.7524L9.28295 11.4733L7.83293 6.00513L9.98194 8.17256L10.5079 11.6964Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07019 8.87821L7.72013 6.05151L9.07614 11.1652L9.13688 11.6894L8.35266 9.40939L7.07019 8.87821Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2156 14.8102L12.9286 14.2837L13.5609 13.2782L11.5593 14.3859L11.2156 14.8102ZM11.7349 14.1471L13.4374 13.2049L12.387 13.287L11.8597 13.9694L11.7349 14.1471Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6416 14.3858L13.6431 13.2781L13.0109 14.2835L11.2979 14.8101L11.6416 14.3858Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99676 14.5997L6.24127 13.3318L8.36998 14.3519L8.50346 14.5316L8.65427 14.6877L8.94092 14.9846L6.99676 14.5997ZM7.43894 13.1016L8.20183 14.1256L8.21118 14.1382L6.30802 13.2262L7.43894 13.1016Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99676 14.531L6.24127 13.2632L8.36998 14.2833L8.50346 14.4629L8.65427 14.6191L8.94092 14.9159L6.99676 14.531ZM8.07722 14.0053L8.20183 14.0569L8.21118 14.0695L8.07722 14.0053Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8015 8.4751L13.9113 11.1748L12.1452 11.4034L11.6555 9.8825L11.6605 9.86779L13.8015 8.4751ZM11.5903 10.075L12.0386 11.4676L10.8263 14.0902L10.9768 12.4389L10.8863 12.1578L10.8988 12.1157L11.5903 10.075ZM11.0499 15L10.7355 15L10.7895 14.4593L12.1438 11.5295L13.8126 11.3135L11.0499 15Z",
    fill: "#88CA8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5903 10.075L12.0387 11.4677L10.8264 14.0903L10.9768 12.439L10.8863 12.1579L10.8987 12.1161L11.5903 10.075Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0499 15L10.7355 15L10.7629 14.5168L12.1438 11.5295L13.8126 11.3135L11.0499 15Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71017 11.3184L8.29359 9.6438L8.97579 11.6217L9.0464 11.8456L8.77494 12.3141L9.0464 13.4385L9.45112 14.6026L7.71017 11.3184ZM8.44179 14.2951L9.01265 14.9853L9.51637 14.9853L7.60895 11.3871L6.06815 11.4254L6.5165 11.9674L7.50812 13.0012L8.44179 14.2951ZM6 11.3021L7.60145 11.2624L8.21732 9.49459L6 8.58105L6 11.3021Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01265 14.9853L9.51637 14.9853L7.60895 11.3871L6.06815 11.4254L6.5165 11.9674L7.50812 13.0012L8.44179 14.2951L9.01265 14.9853ZM6 11.3021L7.60145 11.2624L8.21732 9.49459L6 8.58105L6 11.3021Z",
    fill: "#88CA8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01262 14.9851L9.51634 14.9851L7.60892 11.387L6.06812 11.4252L6.51644 11.9672L7.50809 13.0011L8.44179 14.295L9.01262 14.9851Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6532 14.9781L10.8827 12.5898L9.99675 13.4262L10.1989 14.9803L10.6532 14.9781ZM10.0772 14.9802L9.87588 13.4328L8.93683 12.5393L9.63688 14.978L10.0772 14.9802ZM9.93291 13.3174L8.89557 12.3303L9.77656 10.9619L10.8764 12.4266L9.93291 13.3174Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0772 14.9802L9.87588 13.4328L8.93683 12.5393L9.63688 14.978L10.0772 14.9802ZM9.93291 13.3174L8.89557 12.3303L9.77656 10.9619L10.8764 12.4266L9.93291 13.3174Z",
    fill: "#88CA8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0772 14.9803L9.87588 13.4328L8.93683 12.5393L9.63689 14.9781L10.0772 14.9803Z",
    fill: "#3F9243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10.1352C17 12.3432 16.0161 14.317 14.4707 15.6258L13.5 20.2433L14.6667 25.0001H5.33333L6.5 20.2433L5.52927 15.6258C3.98394 14.317 3 12.3432 3 10.1352C3 6.19453 6.13401 3 10 3C13.866 3 17 6.19453 17 10.1352ZM9.99994 16.6759C13.5438 16.6759 16.4166 13.7476 16.4166 10.1353C16.4166 6.52305 13.5438 3.59473 9.99994 3.59473C6.45612 3.59473 3.58328 6.52305 3.58328 10.1353C3.58328 13.7476 6.45612 16.6759 9.99994 16.6759Z",
    fill: "#4CAF50"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6441_460035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentCrystalHarvested);
export default __webpack_public_path__ + "static/media/Experiment_CrystalHarvested.9e156abfd26706dfffe03aca70e3aeb6.svg";
export { ForwardRef as ReactComponent };